import React, { Component } from 'react'
import axios from 'axios'
import InputButton from '../Design/InputButton'
import { backendUrl } from '../../Services/backend-url'

import './payday.css'

export default class PaydayForm extends Component {
  state = {
    payday: '',
    recurrence: '',
    amount: '',
    username: this.props.username,
  }

  handlePaydayChange = e => {
    this.setState({ payday: e.target.value })
  }

  handleRecChange = e => {
    this.setState({ recurrence: e.target.value })
  }

  handleAmountChange = e => {
    this.setState({ amount: e.target.value })
  }

  handleSubmit = e => {
    e.preventDefault()

    axios.post(backendUrl + 'payday/new', this.state)
      .then(res => this.props.nextStep())
  }

  render() {
    return (
      <form className='fade-in account-info-form font150 roboto' onSubmit={this.handleSubmit}>
        <h3 className='fw500 mb'>Add Payday</h3>
        <label className='font75' htmlFor='payday'>Payday: </label>
        <input className='font100 text-center mb input-2' type='text' id='payday' name='payday' onChange={this.handlePaydayChange} placeholder='mm/dd/year' />
        <label className='font75' htmlFor='recurrence'>Recurrence: </label>
        <select className='font100 text-center mb' id='recurrence' name='recurrence' onChange={this.handleRecChange}>
          <option>Select...</option>
          <option>monthly</option>
          <option>bi-weekly</option>
          <option>weekly</option>
        </select>
        <label className='font75' htmlFor='amount'>Amount: </label>
        <input className='font100 text-center mb input-2' type='text' id='amount' name='amount' onChange={this.handleAmountChange} placeholder='$1500' />
        <InputButton addClass='button-1 font75 mt' inputType='submit' text='Add Payday' />
      </form>
    )
  }
}
